import Hero from "./components/molecules/Hero";

function App() {
  return (
    <div className="App">
      <header>
        <Hero />
      </header>
    </div>
  );
}

export default App;
